import Payment from './payment'
import { APIClient } from '@/infrastructure/network/Gmo/APIClient'

export default class GmoGateway {
  apiClient: APIClient
  Payment: Payment

  constructor(apiClient: APIClient) {
    this.apiClient = apiClient
    this.Payment = new Payment(apiClient)
  }
}
